import React, { useMemo } from 'react';
import { AsyncDisplay, LoadingMessage } from 'js/components';
import { Card, CardBody } from 'reactstrap';
import OrgTreeView from 'js/routes/Organizations/components/ManageOrg/OrgTreeVeiw/OrgTreeView';
import { normalizeOrg } from 'js/utils/org-utils';

function ManageOrg({
  organization,
  loading,
  errorLoading,
  teams,
  rootOrgs,
  onAddTeamsToOrg,
  onAddGroup,
  onAddOrgRef,
  onRemoveNode,
  onRename,
  onPromoteToOrg,
  onReparentGroup,
  onMoveTeam,
}) {
  const orgTree = useMemo(() => {
    return organization ? normalizeOrg(organization) : null;
  }, [organization]);

  return (
    <div className="manage-org">
      <Card>
        <CardBody>
          <AsyncDisplay
            isLoading={!organization && !errorLoading && loading}
            isError={errorLoading}
          >
            <AsyncDisplay.Loading>
              <LoadingMessage iconSize="2x">
                Loading your org&hellip;
              </LoadingMessage>
            </AsyncDisplay.Loading>
            <AsyncDisplay.Error>
              <p className="error">
                Uh oh! Looks like there was a problem loading the organization.
              </p>
            </AsyncDisplay.Error>
            <AsyncDisplay.Resolved>
              {organization && (
                <OrgTreeView
                  orgTree={orgTree}
                  teams={teams}
                  rootOrgs={rootOrgs}
                  onAddTeamsToOrg={onAddTeamsToOrg}
                  onAddGroup={onAddGroup}
                  onAddOrgRef={onAddOrgRef}
                  onRemoveNode={onRemoveNode}
                  onRename={onRename}
                  onPromoteToOrg={onPromoteToOrg}
                  onReparentGroup={onReparentGroup}
                  onMoveTeam={onMoveTeam}
                />
              )}
            </AsyncDisplay.Resolved>
          </AsyncDisplay>
        </CardBody>
      </Card>
    </div>
  );
}

export default ManageOrg;
